<script>
  import AmpelBoxVersionEins from "../AmpelBoxVersionEins.svelte";
  import LineBarMixedChartStacked from "../LineBarMixedChartStacked.svelte";
  import { get_labels } from "../SixModulesUtils.svelte";
  import { get_year_month_key, object_values } from "../Utils.svelte";

  export let year = 2090;
  let target_start = 500;
  let target_end = 1000;
  export let time_modus;

  export let sold_boli_current;
  export let laender_dict;
  export let is_marketing_goal_reached;
  export let sold_bolus_current_marketing_target;

  export let sales_target = {
    "2023-01": 20,
    "2023-02": 30,
  };

  export let marketing_target = {
    "2023-01": 20,
    "2023-02": 30,
  };

  export let sold_boli_new_custs_dict = {
    "2023-01": 20,
    "2023-02": 30,
  };

  export let sold_boli_old_custs_dict = {
    "2023-01": 40,
    "2023-02": 25,
  };

  export let weighted_prediction = {
    "2023-01": 20,
    "2023-02": 30,
  };

  export let unweighted_prediction = {
    "2023-01": 20,
    "2023-02": 30,
  };

  let redraw;

  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [25, 35, 45, 55],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
      {
        label: "Dataset 2",
        data: [20, 30, 35, 50],
        type: "line",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 3",
        data: [20, 30, 35, 50],
        type: "bar",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 4",
        data: [15, 20, 30, 45],
        type: "bar",
        borderColor: "#d9d9d9",
        pointRadius: 0,
      },
    ],
  };

  $: {
    marketing_target, sales_target, sold_boli_new_custs_dict, sold_boli_old_custs_dict, weighted_prediction, unweighted_prediction;

    if (
      marketing_target &&
      sales_target &&
      sold_boli_new_custs_dict &&
      sold_boli_old_custs_dict &&
      weighted_prediction &&
      unweighted_prediction
    ) {
      console.log("marketing_target: ", marketing_target);
      console.log("sales_target: ", sales_target);
      console.log("weighted_prediction: ", weighted_prediction);
      console.log("weighted_prediction: ", object_values(unweighted_prediction));

      if (time_modus == "monthly") {
        data = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: "Marketing Target",
              data: object_values(marketing_target),
              type: "line",
              borderColor: "#00B0F0",
              pointRadius: 0,
              yAxisID: "y_unstacked",
              order: 2,
            },
            {
              label: "Sales Target",
              data: object_values(sales_target),
              type: "line",
              borderColor: "#00B0F0",
              pointRadius: 0,
              yAxisID: "y_unstacked",
              borderDash: [3, 3],
              order: 1,
            },
            {
              label: "New",
              data: object_values(sold_boli_new_custs_dict),
              type: "bar",
              borderColor: "#abcea9",
              pointRadius: 0,
              yAxisID: "y",
              borderDash: [3, 3],
              order: 1,
            },
            {
              label: "Expansion",
              data: object_values(sold_boli_old_custs_dict),
              type: "bar",
              borderColor: "#538c50",
              pointRadius: 0,
              yAxisID: "y",
              borderDash: [3, 3],
              order: 1,
            },
            {
              label: "Weighted Prediction",
              data: object_values(weighted_prediction),
              type: "line",
              borderColor: "#872384",
              pointRadius: 0,
              yAxisID: "y_unstacked",
              order: 3,
            },
            {
              label: "Unweighted Prediction",
              data: object_values(unweighted_prediction),
              type: "line",
              borderColor: "#872384",
              pointRadius: 0,
              yAxisID: "y_unstacked",
              borderDash: [3, 3],
              order: 4,
            },
          ],
        };

        if (time_modus == "quaterly" || time_modus == "biannual") {
        }

        redraw = false;
        redraw = true;
      }
    }
  }
</script>

<div class="row">
  <div class="col" style="padding-right: 6px;">
    <AmpelBoxVersionEins
      target={0}
      current_target={sold_bolus_current_marketing_target}
      current={sold_boli_current}
      unterer_text={"Active boluses " +
        (new Date().getFullYear() == year ? get_year_month_key(new Date()).substring(5, 7) : "12") +
        "/" +
        (year - 2000).toString()}
    />
  </div>

  <div class="col" style="padding-right: 6px;">
    <div
      class="row"
      style="position:relative; background-color: #f2f2f2; height:120px; margin-top: 0px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;"
    >
      <div class="col-6">
        {#each laender_dict.slice(0, Math.ceil(laender_dict.length / 2)) as land, index}
          {#if land["long"] in is_marketing_goal_reached}
            {#if is_marketing_goal_reached[land["long"]]}
              <div><span class="dot-innen-gruen" /> {land["short"]}</div>
            {:else}
              <div><span class="dot-innen-orange" /> {land["short"]}</div>
            {/if}
          {/if}
        {/each}
      </div>

      <div class="col-6">
        {#each laender_dict.slice(Math.ceil(laender_dict.length / 2), laender_dict.length) as land, index}
          {#if land["long"] in is_marketing_goal_reached}
            {#if is_marketing_goal_reached[land["long"]]}
              <div><span class="dot-innen-gruen" /> {land["short"]}</div>
            {:else}
              <div><span class="dot-innen-orange" /> {land["short"]}</div>
            {/if}
          {/if}
        {/each}
      </div>
    </div>
  </div>
</div>

<div class="row" style="width:100%; margin: 0px;">
  <div class="col" style="max-width:10px!important;"><div class="vertical-center rotate" /></div>
  <div class="col" style="margin:0px; padding:0px; height:0px;">
    <LineBarMixedChartStacked
      id={Math.floor(Math.random() * 1000000)}
      line_data={data}
      barPercentage={0.5}
      categoryPercentage={time_modus == "monthly" ? 0.9 : 0.3}
      type={"bar"}
      k={true}
      bind:redraw
    />
  </div>
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }

  .dot-innen-gruen {
    height: 10px;
    width: 10px;
    background-color: #c1e010;
    border-radius: 50%;
    display: inline-block;
    border-width: 0.25pt;
    border-style: solid;
    border-color: white;
  }

  .dot-innen-orange {
    height: 10px;
    width: 10px;
    background-color: #ffc000;
    border-radius: 50%;
    display: inline-block;
    border-width: 0.25pt;
    border-style: solid;
    border-color: white;
  }
</style>
